import React, { Component } from 'react';
import CustomMarkdown from 'component/base/CustomMarkdown';
import { detectIsPadOrMobileByScreenWidth } from 'utils/ScreenUtils';

class ShortDescription extends Component {
  render() {
    return (
      <div className={`short_description ${detectIsPadOrMobileByScreenWidth() ? "body-1" : "field-text"}`}>
        <CustomMarkdown>{this.props.description}</CustomMarkdown>
      </div>
    );
  }
}

export default ShortDescription;
